// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"a47b36bc","389":"d5489527","453":"825386d9","895":"7a4bac63"}[chunkId] + ".chunk.js";
};